import styled, { keyframes } from "styled-components";
import { COLORS } from "../../utils";

interface SpinnerProps {
  size?: number; // pixels,default 48px
  color?: string; // hex color, default primary500
}

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Spinner = styled.div<SpinnerProps>`
  border: ${({ size }) => (size ? size / 8 : 4)}px solid
    ${({ color }) => color ?? COLORS.primary500};
  border-top: ${({ size }) => (size ? size / 8 : 4)}px solid transparent;
  border-radius: 50%;
  width: ${({ size }) => size ?? 48}px;
  height: ${({ size }) => size ?? 48}px;
  animation: ${spin} 1s linear infinite;
`;
